export enum CommonsUI {
  BUTTON_MIN_W = 60,
  BUTTON_MIN_H = 40,
  IMAGE_MIN_W = 200,
  IMAGE_MIN_H = 100,
  BUTTON_IMAGE_MIN_W = 120,
  BUTTON_IMAGE_MIN_H = 50,
  CAROUSEL_MIN_W = 300,
  CAROUSEL_MIN_H = 250,
  DEFAULT_DY = 0,
  DEFAULT_DX = 0,
  VIDEO_W = 350,
  VIDEO_H = 280,

}
export const TWELVE= 8*60*60*1000
export const ROUTER_VIEW= "view"
export const INFORMATION_PERSONAL= "information_personal"
export const CONSTANTS = {
  EMPTY_STRING: "",
}
